import React from 'react';
import { HeroBanner } from '../Modules/HeroBanner';
import { HeroBannerMultiple } from '../Modules/HeroBannerMultiple';
import { HeroBannerwithCopy } from '../Modules/HeroBannerwithCopy';
import { HeroBannerWithTitle } from '../Modules/HeroBannerWithTitle';
import { SpecialCallOut } from '../Modules/SpecialCallOut';
import { MainTitle } from '../Modules/MainTitle';
import { UspModule } from '../Modules/UspModule';
import { TitleWithImage } from '../Modules/TitleWithImage';
import { RecruitmentCases } from '../Modules/RecruitmentCases';
import { MultiCaseTabBanner } from '../Modules/MultiCaseTabBanner';
import { Faqs } from '../Modules/Faqs';
import { ContentBlock } from '../Modules/ContentBlock';
import { CTAModule } from '../Modules/CTAModule';
import { TexthtmlEditorModule } from '../Modules/TexthtmlEditorModule';

const LandingPageModuleHeroBannerFullScreen = ({ restProps }) => {
	return <HeroBanner props={restProps} fullScreen={true} />;
};

const LandingPageModuleHeroBanner = ({ restProps }) => {
	return <HeroBanner props={restProps} fullScreen={false} />;
};

const LandingPageModuleHeroBannerMultiple = ({ restProps }) => {
	return <HeroBannerMultiple props={restProps} />;
};

const LandingPageModuleMultipleBannerWithCopy = ({ restProps }) => {
	return <HeroBannerwithCopy props={restProps} />;
};

const LandingPageModuleSpecialCallOut = ({ restProps }) => {
	return <SpecialCallOut props={restProps} />;
};

const LandingPageModuleMainTitle = ({ restProps }) => {
	return <MainTitle props={restProps} />;
};

const LandingPageModuleUsp = ({ restProps }) => {
	return <UspModule props={restProps} />;
};

const LandingPageModuleTitleWithImage = ({ restProps }) => {
	return <TitleWithImage props={restProps} />;
};

const LandingPageModuleHeroBannerWithTitle = ({ restProps }) => {
	return <HeroBannerWithTitle props={restProps} />;
};

const LandingPageModuleRecruitmentCases = ({ restProps }) => {
	return <RecruitmentCases props={restProps} />;
};

const LandingPageModuleMultiCaseTabBanner = ({ restProps }) => {
	return <MultiCaseTabBanner props={restProps} />;
};

const LandingPageModuleFaqs = ({ restProps }) => {
	return <Faqs props={restProps} />;
};

const LandingPageModuleContentBlock = ({ restProps }) => {
	return <ContentBlock props={restProps} />;
};

const LandingPageModuleCta = ({ restProps }) => {
	return <CTAModule props={restProps} />;
};

const LandingPageModuleTexthtmlEditor = ({ restProps }) => {
	return <TexthtmlEditorModule props={restProps} />;
};

const Components = {
	landingPageModuleHeroBannerFullScreen: LandingPageModuleHeroBannerFullScreen,
	landingPageModuleHeroBanner: LandingPageModuleHeroBanner,
	landingPageModuleHeroBannerMultiple: LandingPageModuleHeroBannerMultiple,
	specialCallOut: LandingPageModuleSpecialCallOut,
	landingPageModuleMainTitle: LandingPageModuleMainTitle,
	landingPageModuleUsp: LandingPageModuleUsp,
	landingPageModuleTitleWithImage: LandingPageModuleTitleWithImage,
	landingPageModuleHeroBannerWithTitle: LandingPageModuleHeroBannerWithTitle,
	landingPageModuleRecruitmentCases: LandingPageModuleRecruitmentCases,
	landingPageModuleMultiCaseTabBanner: LandingPageModuleMultiCaseTabBanner,
	landingPageModuleMultipleBannerWithCopy:
		LandingPageModuleMultipleBannerWithCopy,
	landingPageModuleFaQs: LandingPageModuleFaqs,
	landingPageModuleContentBlock: LandingPageModuleContentBlock,
	landingPageModuleCta: LandingPageModuleCta,
	landingPageModuleTexthtmlEditor: LandingPageModuleTexthtmlEditor,
};

function TemplateFinder({ component: Component, restProps }) {
	if (typeof Components[Component] !== 'undefined') {
		let marginBottom = restProps?.marginBottom ? restProps?.marginBottom : '60';
		let marginTop = restProps?.marginTop ? restProps?.marginTop : '0';

		return (
			<section
				className={'mb-' + marginBottom + ' mt-' + marginTop}
				id={restProps?.sectionId}
			>
				{React.createElement(Components[Component], {
					restProps,
				})}
			</section>
		);
	}
	return React.createElement(() => (
		<div className='container'>
			<div className='mb-20'>
				The component {Component} has not been created yet.
			</div>
		</div>
	));
}

export default TemplateFinder;
